import React from 'react';
import { Card, Typography, Divider, Button, Table } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const CookiePolicy: React.FC = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const cookieData = [
        {
            key: '1',
            nome: 'auth0.*',
            tipo: 'Tecnico/Necessario',
            durata: 'Sessione / 7 giorni',
            scopo: 'Gestione autenticazione e sessione utente tramite Auth0',
            terze: 'Auth0 (auth0.com)'
        },
        {
            key: '2',
            nome: '_legacy_auth0.*',
            tipo: 'Tecnico/Necessario',
            durata: 'Sessione',
            scopo: 'Supporto autenticazione per browser legacy',
            terze: 'Auth0 (auth0.com)'
        }
    ];

    const columns = [
        {
            title: 'Nome Cookie',
            dataIndex: 'nome',
            key: 'nome',
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo',
            key: 'tipo',
        },
        {
            title: 'Durata',
            dataIndex: 'durata',
            key: 'durata',
        },
        {
            title: 'Scopo',
            dataIndex: 'scopo',
            key: 'scopo',
        },
        {
            title: 'Parti Terze',
            dataIndex: 'terze',
            key: 'terze',
        }
    ];

    return (
        <div style={{
            background: 'linear-gradient(135deg, #fef4f4 0%, #fff9f9 100%)',
            minHeight: '100vh',
            padding: isMobile ? '20px' : '40px'
        }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate('/')}
                    style={{ marginBottom: '24px' }}
                >
                    Torna alla Home
                </Button>

                <Card style={{
                    borderRadius: '16px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                }}>
                    <Title level={1} style={{ textAlign: 'center', marginBottom: '8px' }}>
                        Cookie Policy
                    </Title>
                    <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: '32px' }}>
                        Ultimo aggiornamento: 11 Novembre 2024
                    </Text>

                    <Divider />

                    <Title level={3}>1. Cosa sono i Cookie?</Title>
                    <Paragraph>
                        I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo (computer,
                        tablet, smartphone) quando visiti un sito web. I cookie permettono al sito di ricordare le tue
                        azioni e preferenze per un certo periodo di tempo, così non devi reinserirle ogni volta che
                        torni sul sito o navighi da una pagina all'altra.
                    </Paragraph>

                    <Title level={3}>2. Come Utilizziamo i Cookie</Title>
                    <Paragraph>
                        babbonatalesegreto.icu utilizza <Text strong>esclusivamente cookie tecnici necessari</Text> per
                        il funzionamento del servizio di autenticazione. Non utilizziamo cookie di profilazione,
                        cookie pubblicitari o cookie di tracciamento per scopi di marketing.
                    </Paragraph>

                    <Title level={3}>3. Tipi di Cookie Utilizzati</Title>

                    <Title level={4}>3.1 Cookie Tecnici Necessari</Title>
                    <Paragraph>
                        Questi cookie sono essenziali per il funzionamento del sito e non possono essere disattivati
                        nei nostri sistemi. Sono generalmente installati solo in risposta ad azioni da te effettuate
                        (accesso, compilazione form). Puoi configurare il browser per bloccare questi cookie, ma alcune
                        parti del sito potrebbero non funzionare.
                    </Paragraph>

                    <Title level={4}>3.2 Cookie di Autenticazione (Auth0)</Title>
                    <Paragraph>
                        Utilizziamo Auth0 come servizio di autenticazione sicura. Auth0 installa cookie tecnici
                        necessari per:
                    </Paragraph>
                    <ul>
                        <li>Gestire la tua sessione di autenticazione</li>
                        <li>Mantenere lo stato di login</li>
                        <li>Proteggere il tuo account da accessi non autorizzati</li>
                        <li>Implementare misure di sicurezza (CSRF protection)</li>
                    </ul>
                    <Paragraph>
                        Per maggiori informazioni sui cookie di Auth0, consulta la loro
                        <a href="https://auth0.com/docs/secure/security-guidance/data-security/cookies"
                           target="_blank"
                           rel="noopener noreferrer"
                           style={{ marginLeft: '4px' }}>
                            Cookie Policy
                        </a>.
                    </Paragraph>

                    <Title level={3}>4. Elenco Dettagliato dei Cookie</Title>
                    <div style={{ overflowX: 'auto', marginTop: '16px' }}>
                        <Table
                            dataSource={cookieData}
                            columns={columns}
                            pagination={false}
                            bordered
                            size={isMobile ? 'small' : 'middle'}
                            scroll={isMobile ? { x: 800 } : undefined}
                        />
                    </div>

                    <Title level={3} style={{ marginTop: '32px' }}>5. Cookie di Terze Parti</Title>
                    <Paragraph>
                        I cookie di Auth0 sono considerati cookie di terze parti in quanto installati da un dominio
                        diverso dal nostro (auth0.com). Questi cookie sono necessari per il funzionamento del servizio
                        di autenticazione e non possono essere disattivati se desideri utilizzare il nostro servizio.
                    </Paragraph>

                    <Title level={3}>6. Cosa NON Facciamo con i Cookie</Title>
                    <Paragraph>
                        babbonatalesegreto.icu NON utilizza:
                    </Paragraph>
                    <ul>
                        <li><Text strong>Cookie di profilazione:</Text> Non tracciamo le tue abitudini di navigazione</li>
                        <li><Text strong>Cookie pubblicitari:</Text> Non mostriamo pubblicità personalizzate</li>
                        <li><Text strong>Cookie di analisi:</Text> Non utilizziamo Google Analytics o simili</li>
                        <li><Text strong>Cookie di social media:</Text> Non integriamo widget di Facebook, Twitter, ecc.</li>
                    </ul>

                    <Title level={3}>7. Gestione dei Cookie</Title>
                    <Paragraph>
                        Puoi controllare e/o eliminare i cookie come desideri. Puoi eliminare tutti i cookie già
                        presenti sul tuo dispositivo e puoi impostare la maggior parte dei browser per impedirne
                        l'installazione.
                    </Paragraph>

                    <Title level={4}>7.1 Impostazioni del Browser</Title>
                    <Paragraph>
                        Ecco come gestire i cookie nei browser più comuni:
                    </Paragraph>
                    <ul>
                        <li>
                            <Text strong>Chrome:</Text> Impostazioni → Privacy e sicurezza → Cookie e altri dati dei siti
                            (<a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">guida</a>)
                        </li>
                        <li>
                            <Text strong>Firefox:</Text> Impostazioni → Privacy e sicurezza → Cookie e dati dei siti web
                            (<a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer">guida</a>)
                        </li>
                        <li>
                            <Text strong>Safari:</Text> Preferenze → Privacy → Gestisci dati siti web
                            (<a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">guida</a>)
                        </li>
                        <li>
                            <Text strong>Edge:</Text> Impostazioni → Cookie e autorizzazioni sito → Gestisci ed elimina cookie
                            (<a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">guida</a>)
                        </li>
                    </ul>

                    <Title level={4}>7.2 Conseguenze della Disattivazione</Title>
                    <Paragraph>
                        ⚠️ <Text strong>Attenzione:</Text> Disattivando i cookie tecnici di Auth0, non potrai
                        accedere al servizio e utilizzare le funzionalità di babbonatalesegreto.icu.
                    </Paragraph>

                    <Title level={3}>8. Base Giuridica</Title>
                    <Paragraph>
                        Ai sensi della normativa privacy europea (Direttiva ePrivacy e GDPR), i cookie tecnici
                        strettamente necessari per il funzionamento del servizio non richiedono il consenso
                        dell'utente. I cookie di Auth0 rientrano in questa categoria.
                    </Paragraph>

                    <Title level={3}>9. Aggiornamenti</Title>
                    <Paragraph>
                        Questa Cookie Policy può essere aggiornata periodicamente per riflettere modifiche nelle
                        nostre pratiche o nelle normative applicabili. Ti invitiamo a consultare regolarmente
                        questa pagina.
                    </Paragraph>

                    <Title level={3}>10. Contatti</Title>
                    <Paragraph>
                        Per domande sulla nostra Cookie Policy o per esercitare i tuoi diritti in materia di privacy,
                        consulta la nostra <a href="/privacy">Privacy Policy</a> o contattaci all'indirizzo email:
                        <a href="mailto:info@marchiosoft.com" style={{ marginLeft: '4px' }}>info@marchiosoft.com</a>
                    </Paragraph>

                    <Divider />

                    <div style={{ textAlign: 'center', marginTop: '32px' }}>
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => navigate('/')}
                        >
                            Torna alla Home
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default CookiePolicy;
